import { ReenrollStatus } from '@/models/self-management'
import { Api } from '@coderhouse/common'

async function getReenrollStatus(reenrollData: any): Promise<ReenrollStatus> {
  const response = await Api.put(`${process.env.VUE_APP_CH_API_BFF}/v1/campus/courses-purchase/reenroll/paid`, reenrollData)
  return response
}

async function failReenrollCommissionPurchase(params: Record<string, string>) {
  return Api.post(`${process.env.VUE_APP_CH_API_BFF}/v1/campus/commissions-purchase/penalty/fail`, params)
}

async function failReenrollProductPurchase(params: Record<string, string>) {
  return Api.post(`${process.env.VUE_APP_CH_API_BFF}/v1/campus/courses-purchase/penalty/fail`, params)
}

async function failTransferPurchase(params: Record<string, string>) {
  return Api.post(`${process.env.VUE_APP_CH_API_BFF}/v1/campus/transfer-purchase/penalty/fail`, params)
}

async function approveReenrollCommissionPurchase(params: Record<string, string>) {
  return Api.post(`${process.env.VUE_APP_CH_API_BFF}/v1/campus/commissions-purchase/penalty/ok`, params)
}

async function approveReenrollProductPurchase(params: Record<string, string>) {
  return Api.post(`${process.env.VUE_APP_CH_API_BFF}/v1/campus/courses-purchase/penalty/ok`, params)
}

async function approveTransferPurchase(params: Record<string, string>) {
  return Api.post(`${process.env.VUE_APP_CH_API_BFF}/v1/campus/transfer-purchase/penalty/ok`, params)
}

export {
  getReenrollStatus,
  failReenrollCommissionPurchase,
  failReenrollProductPurchase,
  failTransferPurchase,
  approveReenrollCommissionPurchase,
  approveReenrollProductPurchase,
  approveTransferPurchase
}
